import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, requireApproved = false }) => {
  const { isAuthenticated, isApproved, isPending, loading, isRejected } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // If user is not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If route requires approved status and user is not approved
  if (requireApproved && !isApproved) {
    // If user is pending, show pending page
    if (isPending) {
      return <Navigate to="/pending-approval" replace />;
    }

    if (isRejected) {
      return <Navigate to="/access-denied" replace />;
    }
    
    // Otherwise, redirect to a rejected page or home
    return <Navigate to="/apply" replace />;
  }

  // If all checks pass, render the protected component
  return children;
};

export default ProtectedRoute;
